export const TOGGLE_MINICART = "TOGGLE_MINICART";
export function toggleMiniCart() {
    return {
        type: TOGGLE_MINICART,
    };
}
